import { render, staticRenderFns } from "./TopicAddOrEdit.vue?vue&type=template&id=325688d3&scoped=true&"
import script from "./TopicAddOrEdit.vue?vue&type=script&lang=js&"
export * from "./TopicAddOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./TopicAddOrEdit.vue?vue&type=style&index=0&id=325688d3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325688d3",
  null
  
)

export default component.exports